const opendayLandingInit = () => {
    const opendayLandings = document.querySelectorAll('.s-openday-landing');

    opendayLandings.forEach(opendayLanding => {
        const scrollDownButton =
            opendayLanding.querySelector('.js-scroll-down');

        if (scrollDownButton) {
            scrollDownButton.addEventListener('click', () => {
                const { nextElementSibling } = opendayLanding;

                if (nextElementSibling) {
                    nextElementSibling.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });
                }
            });
        }

        const { videoMobile, videoDesktop } = opendayLanding.dataset;

        if (videoMobile && videoDesktop) {
            const mql = window.matchMedia('(min-width: 768px)');
            const videoEl = opendayLanding.querySelector('video');
            const sourceEl = document.createElement('source');
            videoEl.appendChild(sourceEl);

            mql.addEventListener('change', e => {
                if (e.matches) {
                    sourceEl.setAttribute('src', videoDesktop);
                } else {
                    sourceEl.setAttribute('src', videoMobile);
                }
                videoEl.load();
            });

            if (mql.matches) {
                sourceEl.setAttribute('src', videoDesktop);
            } else {
                sourceEl.setAttribute('src', videoMobile);
            }
            videoEl.load();
        }
    });
};

document.addEventListener('DOMContentLoaded', opendayLandingInit);
